export enum FeatureFlag {
  VAX_LOC_IDS = "VAX_LOC_IDS",
  GROWTH_CACHED_SLOTS_ENABLED = "GROWTH_CACHED_SLOTS_ENABLED",
  GROWTH_WEBSITE_BANNER = "GROWTH_WEBSITE_BANNER",
  GROWTH_LOCATION_PAGE_GOOGLE_MAPS_REDIRECT_BOOKING = "GROWTH_LOCATION_PAGE_GOOGLE_MAPS_REDIRECT_BOOKING",
}
